import cx from 'classnames'

import { TextArea } from '@components/TextArea'
import { TextAreaFieldProps } from './interface'

export function TextAreaField({
  className,
  textAreaClassName,
  label,
  leftIcon,
  error,
  touched,
  showErrorMsg,
  ...props
}: TextAreaFieldProps) {
  return (
    <div
      className={cx(
        'text-[14px] text-secondary-1 dark:text-dark-10',
        className
      )}
      id={props.name}
    >
      {label && (
        <label className='block mb-[4px] text-[12px] font-light'>{label}</label>
      )}
      <div className='relative flex w-full'>
        {leftIcon && (
          <div className='absolute left-0 ml-[20px] mt-[10px]'>{leftIcon}</div>
        )}
        <TextArea
          data-test={props.name}
          className={cx(
            'font-light placeholder:text-secondary-1',
            textAreaClassName,
            {
              'pl-[50px]': leftIcon,
              '!border-red': touched && error,
            }
          )}
          {...props}
        />
      </div>
      {showErrorMsg && touched && error && (
        <div className='flex items-center mt-[10px]'>
          <div className='text-[12px] text-red-3'>{error}</div>
        </div>
      )}
    </div>
  )
}
